import { Injectable } from '@angular/core';
import { InvoiceLine, Service, ServiceBooking } from '../../models';
import { InvoicingService } from './invoicing.service';
import { ServiceService } from '../../data';

export class ServiceInvoiceData {
  cost: number;
  quantity: number;
  service: string;
}

/**
 * Service containing tools for converting the data of a ServiceBooking into information relevant to invoicing
 */
@Injectable()
export class ServiceBookingInvoiceService extends InvoicingService {

  private services: Service[] = [];

  constructor(
    private serviceService: ServiceService,
  ) {
    super();

    this.serviceService.getAll().subscribe(services => {
      this.services = services['hydra:member'];
    });
  }

  enhanceServiceBookingsService(serviceBookings: ServiceBooking[]): ServiceBooking[] {
    return serviceBookings.map(serviceBooking => {
      serviceBooking.service = this.services.find(
        service => serviceBooking.service === service['@id'],
      );
      return serviceBooking;
    });
  }

  /**
   * @param serviceInvoiceData
   * @param currency Must be the currency of the invoicing building
   * @param useServiceQuantity default true, else set each quantity to 1
   */
  // eslint-disable-next-line max-len
  getServiceBookingsLines(serviceInvoiceData: ServiceInvoiceData[], currency: string, useServiceQuantity: boolean = true): InvoiceLine[] {
    const servicesLines: InvoiceLine[] = [];

    serviceInvoiceData.forEach(invoiceLine => {
      const found = servicesLines.find(
        line => line.itemDescription === invoiceLine.service,
      );

      if (found) {
        found.price.quantity += useServiceQuantity ? invoiceLine.quantity : 1;
      } else {
        const servicesLine = new InvoiceLine();

        servicesLine.itemDescription = invoiceLine.service;
        servicesLine.billingObject = 'LUNCH'; // TODO ask to Nicolas Mabriez to create Generic billingObject
        servicesLine.price.invoiceAmount.currency = currency;
        servicesLine.price.invoiceAmount.unitAmount = invoiceLine.cost;
        servicesLine.price.quantity = useServiceQuantity ? invoiceLine.quantity : 1;
        servicesLine.price.vatCode = 1;
        servicesLines.push(servicesLine);
      }
    });

    return servicesLines;
  }

  getServiceInvoiceData(serviceBookings: ServiceBooking[]): ServiceInvoiceData[] {
    const result: ServiceInvoiceData[] = [];

    for (const booking of serviceBookings) {
      const service: Service = booking.service as Service;

      // TODO Modify this format to match with an InvoiceLine Object and adapt in the app
      const bookingInvoiceData: ServiceInvoiceData = {
        cost: service.cost,
        quantity: booking.quantity,
        service: service.name,
      };

      result.push(bookingInvoiceData);
    }

    return result;
  }

  getServices() {
    return this.services;
  }
}
